import { useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { STEPS } from '../helpers';
import { talentOnboardingResumeTooBig } from '../../../redux/actions/talentOnboardingActions';

export const useFilterSteps = ({ customFilters, tnSettings, jobFunctions, network }) => {
  const dispatch = useDispatch();
  return useMemo(
    () =>
      STEPS.reduce((acc, step) => {
        if (step.id === 'category') {
          if (!customFilters.length) return acc;

          acc.push({ ...step, customFilters: customFilters.filter((filter) => filter.options.length) });

          return acc;
        }

        if (step.id === 'jobFunctions') {
          acc.push({ ...step, jobFunctions });

          return acc;
        }

        if (step.id === 'profile') {
          acc.push({ ...step, handleFileTooBig: () => dispatch(talentOnboardingResumeTooBig({ network })) });

          return acc;
        }

        if (step.id === 'complete' && tnSettings?.tnV2SuccessMessageTitle) {
          acc.push({ ...step, title: tnSettings.tnV2SuccessMessageTitle });

          return acc;
        }

        acc.push(step);
        return acc;
      }, []),
    [tnSettings.tnV2SuccessMessageTitle, customFilters, jobFunctions, dispatch, network],
  );
};
